import React, { useState } from "react";
import { Icon } from "@iconify/react";

const Input = ({
  type = "text",
  wrapperClass,
  className,
  inputClass,
  label,
  labelClass,
  onChange,
  name,
  id,
  value,
  placeholder,
  icon,
  maxWidth,
  maxHeight,
  minHeight,
  minWidth,
  height,
  width,
  maxLength,
  error,
  errorMessage,
  disabled = false,
  leftImg,
  ref,
  onInput,
  style,
  onBlur
  
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const inputStyle = {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
  };

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const getInputType = () => {
    if (type === "password") {
      return showPassword ? "text" : "password";
    } else {
      return type;
    }
  };

  const getInputIcon = () => {
    switch (type) {
      case "password":
        return showPassword ? "mingcute:eye-2-fill" : "mdi:eye-off";
      default:
        return icon;
    }
  };

  return (
    <>
      <div className={`input-box ${error ? "error" : ""} ${className}`}>
        {label && <label className={labelClass}>{label}</label>}
        <div
          className={`input-wrapper flex items-center gap-[8px] ${wrapperClass} ${
            disabled && "disabled"
          }`}
          style={inputStyle}
        >
          {leftImg && (
            <img src={leftImg} alt="img" className="w-[16px] h-[16px]" />
          )}
          <input
            autoComplete="off"
            type={getInputType()}
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            className={inputClass}
            disabled={disabled}
            maxLength={maxLength}
            placeholder={placeholder}
            ref={ref}
            onInput={onInput}
            style={style}
            tabIndex={0}
            onBlur={onBlur}
          />
          {icon && (
            <Icon
              icon={getInputIcon()}
              className="cursor-pointer"
              onClick={togglePassword}
              color="#717274"
              width={18}
              height={18}
            />
          )}
        </div>
        {errorMessage && (
          <p className="extra-small text-xs font-medium text-red-600">
            {errorMessage}
          </p>
        )}
      </div>
    </>
  );
};

export default Input;
